// ABOUTME: The copy the receiver screens (4B Forgive, 5B Better Question) share, kept in one place.
// ABOUTME: The headline and sub are identical on all three; each screen's own button label tells them apart when announced.

export const RECEIVER_HEADLINE = 'They made it right — forgive, and move forward together.';
export const RECEIVER_SUB = 'Release is invited — never forced. The seam stays either way.';

// Shown on 5B when the storm has no Better Question (No Storm, or a storm missing from the content).
export const FALLBACK_BETTER_QUESTION = 'Can big weather pass through without taking the wheel?';
